var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTpt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.121 11.628h2.13c.795-.31 2.387-1.307 2.387-2.802 0-1.869-1.869-2.751-2.388-2.803-.416-.042-7.786-.017-11.42 0-.276.052-.83.332-.83 1.038v3.582c.035.33.25.986.83.986h3.322V24.76c.07.19.353.57.935.57h4.36c.224.07.674.053.674-.57V11.628zm5.555 13.703c-.346-.068-1.038-.383-1.038-1.09V12.719c.328-2.231 2.283-6.695 7.474-6.695C29.6 6.023 31 11.629 31 13.6c0 1.973-1.09 4.88-3.01 6.281-1.537 1.122-3.893 1.472-4.88 1.506l-1.505-.363v3.218c-.12.364-.487 1.09-.986 1.09h-3.945zm6.591-9.913a1.765 1.765 0 1 0 0-3.529 1.765 1.765 0 0 0 0 3.53z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTpt);
export default __webpack_public_path__ + "static/media/TPT.a53ea3c25ddacbcb16ff3580dd82df9e.svg";
export { ForwardRef as ReactComponent };